import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Booking from "@/pages/Booking";
import Confirmation from "@/pages/Confirmation";
import Admin from "@/pages/Admin";
import Upsell from "@/pages/Upsell";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" theme="light" offset={80} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/book/:tierId" element={<Booking />} />
          <Route path="/confirmation/:code" element={<Confirmation />} />
          <Route path="/upsell/:code" element={<Upsell />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
